module.exports = __webpack_public_path__ + "media/20.99f17258.mp3";